import React from "react";
import { AlertTriangle, Home, RefreshCcw } from "lucide-react";

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Global Runtime Error:", error, info);
  }

  resetApp = () => {
    this.setState({ hasError: false });
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
          <div className="w-full max-w-lg rounded-2xl border border-blue-100 bg-white p-8 shadow-sm text-center">
            <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-xl bg-rose-50 text-rose-600">
              <AlertTriangle className="h-7 w-7" />
            </div>

            <h1 className="text-xl font-bold text-slate-900">
              Something went wrong
            </h1>

            <p className="mt-2 text-sm font-semibold text-slate-600">
              We couldn’t load this page. Please try again.
            </p>

            <div className="mt-6 flex justify-center gap-3">
              <button
                onClick={this.resetApp}
                className="inline-flex items-center gap-2 rounded-xl border border-blue-200 bg-white px-4 py-2 text-sm font-semibold text-blue-700 hover:bg-blue-50"
              >
                <RefreshCcw className="h-4 w-4" />
                Retry
              </button>

              <a
                href="/"
                className="inline-flex items-center gap-2 rounded-xl bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700"
              >
                <Home className="h-4 w-4" />
                Go Home
              </a>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
